import React, { useEffect, useState } from 'react';
import { getContent } from "../middleware/contentFetch";

const About = () => {
  const [content, setContent] = useState([]);

  useEffect(() => {
      getContent()
        .then(data => {setContent(data.about || {});})
        .catch(() => setContent({}));
    }, []);
  
  return (
    <div style={{"backgroundColor": "#f3e5f5"}}>
      <div className="container py-5" id='about'>
        <div className="text-center mb-5">
          <h1 className="text-primary fw-bold display-4 mb-3">{content['page_title']}</h1>
          <div className="border-bottom fw-bold border-primary mx-auto" style={{ width: '100%' }}></div>
        </div>

        {/* Positioning Section */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-12">
            <div className="card border-0 shadow-sm mb-4">
              <div className="card-body">
                <h2 className="text-primary fw-bold mb-4">{content['title-1']}</h2>
                <p className="lead mb-0">{content['body-1']}</p>
              </div>
            </div>

            {/* Mission and Goal Cards */}
            <div className="row g-4">
              <div className="col-md-6">
                <div className="card border-primary border-2 h-100">
                  <div className="card-body p-4">
                    <h3 className="card-title text-primary fw-bold mb-3">{content['title-2']}</h3>
                    <p className="card-text">{content['body-2']}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card bg-primary text-white h-100">
                  <div className="card-body p-4">
                    <h3 className="card-title fw-bold mb-3">{content['title-3']}</h3>
                    <p className="card-text">{content['body-3']}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contact CTA Section */}
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card bg-light border-0">
              <div className="card-body p-4 p-md-5 text-center">
                <h2 className="text-primary fw-bold mb-4">{content['tag']}</h2>
                <p className="lead mb-4">{content['tag-baseline']}</p>

                {/* Contact Info */}
                <div className="mb-4">
                  <div className="d-flex align-items-center justify-content-center mb-2">
                    <i className="fa-solid fa-phone mx-2 text-primary"></i>
                    <span className="fs-3 fw-bold">{content['contact-no']}</span>
                  </div>
                  
                  <div className="row justify-content-center mt-3">
                    <div className="col-md-8">
                      <div className="d-flex align-items-center justify-content-center mb-2">
                        <i className="fa-solid fa-location-dot mx-2 text-primary"></i>
                        <span>{content['address']}</span>
                      </div>
                      
                      <div className="row justify-content-center text-muted">
                        <div className="col-auto">
                          <i className="fa-regular fa-clock mx-2 text-primary"></i>
                          <span>{content['timing']}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* CTA Button */}
                <a 
                  href="#contact" 
                  className="btn btn-primary btn-lg px-5 py-3 fw-bold"
                  style={{ borderRadius: '50px' }}
                >{content['btn-text']}</a>
              </div>
            </div>
          </div>
        </div>     
      </div>
    </div>

  );
};

export default About;